import { render, staticRenderFns } from "./ZLtable.vue?vue&type=template&id=72b07735&scoped=true"
import script from "./ZLtable.vue?vue&type=script&lang=js"
export * from "./ZLtable.vue?vue&type=script&lang=js"
import style0 from "./ZLtable.vue?vue&type=style&index=0&id=72b07735&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b07735",
  null
  
)

export default component.exports